import { render, staticRenderFns } from "./MbEditorPage.vue?vue&type=template&id=380d4eac&scoped=true&"
import script from "./MbEditorPage.vue?vue&type=script&lang=js&"
export * from "./MbEditorPage.vue?vue&type=script&lang=js&"
import style0 from "./MbEditorPage.vue?vue&type=style&index=0&id=380d4eac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380d4eac",
  null
  
)

export default component.exports